
import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './services.css'; // Your custom styles
const Service = ()=>{
    useEffect(() => {
        AOS.init({
          duration: 1000, // Animation duration in milliseconds
          once: true,     // Animations should happen only once (true) or repeat (false)
        });
      }, []);

    return(
        <section id="featured-services" className="featured-services section">
        {/* Section Title */}
        <div className="container section-title" data-aos="fade-up">
          <h2>Services</h2>
          <p>We offer a comprehensive solution for top-quality web design and development services. Our customized, budget-friendly web design options are tailored to meet your specific needs. Select from our best plans to create a responsive web design that aligns with your requirements.</p>
        </div>
  
        {/* Services */}
        <div className="container" data-aos="fade-up" data-aos-delay="100">
          <div className="row gy-5">
            {/* Service Item 1 */}
            <div className="col-xl-4 col-md-6" data-aos="zoom-in" data-aos-delay="200">
              <div className="service-item">
                <div className="img">
                  <img src="assets/img/services/webdesign.png" className="img-fluid" alt="Service 1" />
                </div>
                <div className="details position-relative">
                  <div className="icon">
                  <i class="bi bi-laptop"></i>
                  </div>
                  <a href="#" className="stretched-link">
                    <h3>Web Design</h3>
                  </a>
                  <p>Create exceptional website designs using advanced user interaction tools like Adobe XD, Figma, and more. Build your global presence with the help of our experts, who specialize in crafting web designs from concept to completion.</p>
                </div>
              </div>
            </div>
            {/* Additional Service Items can be added here */}
          
  
          
  
            <div class="col-xl-4 col-md-6" data-aos="zoom-in" data-aos-delay="500">
              <div class="service-item">
                <div class="img">
                  <img src="assets/img/services/responsiveweb.png" class="img-fluid" alt="" />
                </div>
                <div class="details position-relative">
                  <div class="icon">
                  <i class="bi bi-bounding-box"></i>
                  </div>
                  <a href="#" class="stretched-link">
                    <h3>100% Responsive Websites</h3>
                  </a>
                  <p>Website responsiveness plays a crucial role in the success of your business. Ensure your website is optimized for all devices to effectively reach your target audience. We utilize the latest technologies and frameworks to guarantee 100% responsiveness across all platforms.</p>
                  <a href="#" class="stretched-link"></a>
                </div>
              </div>
            </div>
            {/* <!-- End Service Item --> */}
  
            <div class="col-xl-4 col-md-6" data-aos="zoom-in" data-aos-delay="400">
              <div class="service-item">
                <div class="img">
                  <img src="assets/img/services/webdevelopment.png" class="img-fluid" alt="" />
                </div>
                <div class="details position-relative">
                  <div class="icon">
                  <i class="bi bi-pc-display"></i>
                  </div>
                  <a href="#" class="stretched-link">
                    <h3>Web Development</h3>
                  </a>
                  <p>We are your one-stop solution for top-notch web design and development services. Our customized and cost-effective web design options are tailored to meet your specific needs. Select the best plans to create a responsive web design that perfectly aligns with your requirements.</p>
                </div>
              </div>
            </div>
            {/* <!-- End Service Item --> */}

            <div class="col-xl-4 col-md-6" data-aos="zoom-in" data-aos-delay="600">
              <div class="service-item">
                <div class="img">
                  <img src="assets/img/services/contentwriting.png" class="img-fluid" alt="" />
                </div>
                <div class="details position-relative">
                  <div class="icon">
                  <i class="bi bi-body-text"></i>
                  </div>
                  <a href="#" class="stretched-link">
                    <h3>Content Writing</h3>
                  </a>
                  <p>We provide comprehensive content writing services to meet all your content needs in one place. Our offerings include blog writing for websites, web content creation, marketing materials, research papers, press releases, product descriptions, and more.</p>
                  <a href="#" class="stretched-link"></a>
                </div>
              </div>
            </div>
            {/* <!-- End Service Item --> */}
  
            <div class="col-xl-4 col-md-6" data-aos="zoom-in" data-aos-delay="700">
              <div class="service-item">
                <div class="img">
                  <img src="assets/img/services/logodesign.png" class="img-fluid" alt="" />
                </div>
                <div class="details position-relative">
                  <div class="icon">
                  <i class="bi bi-file-easel"></i>
                  </div>
                  <a href="#" class="stretched-link">
                    <h3>Logo Designs</h3>
                  </a>
                  <p>We offer logo design services tailored to various industries, including real estate, education, finance, food, hospitality, information technology, and fashion, among others. Additionally, we specialize in creating custom logo designs to meet unique client needs.</p>
                  <a href="#" class="stretched-link"></a>
                </div>
              </div>
            </div>
            {/* <!-- End Service Item --> */}
            <div class="col-xl-4 col-md-6" data-aos="zoom-in" data-aos-delay="300">
              <div class="service-item">
                <div class="img">
                  <img src="assets/img/services/support.png" class="img-fluid" alt="" />
                </div>
                <div class="details position-relative">
                  <div class="icon">
                  <i class="bi bi-person-raised-hand"></i>
                  </div>
                  <a href="#" class="stretched-link">
                    <h3>24*7 Free Support</h3>
                  </a>
                  <p>Our clients come first, and we are committed to offering comprehensive customer support across all communication channels. Any issues related to services such as website design and e-commerce development will be handled with the highest priority. We pride ourselves on maintaining a flawless record in customer support.</p>
                </div>
              </div>
            </div>
            {/* <!-- End Service Item --> */}
          </div>
  
        </div>
  
      </section>
      )
}
export default Service